import React from 'react';
import Header from '../Components/Header';
import about from '../Assets/about.png'

const About = () => {
  return (
    <>
    <Header/>
      <div className='flex flex-col justify-between items-center lg:flex-row' >
      <div>
        <img src={about} alt='...' />
      </div>
      <div>
        <h1 class="lg:text-7xl text-5xl font-bold font-sans text-center " >To Win Big</h1>
        <h1 class="lg:text-7xl text-5xl font-bold text-red-700 text-center" >On Football Quiz</h1>
      </div>

      </div>
      <div className='bg-black text-white'>
        <h2 class="flex justify-center lg:text-4xl text-2xl font-mono items-center font-bold m-0" >About Football Quiz
</h2>
<div class="w-[250px] lg:w-[700px] md:w-[300px] mx-auto p-2" >
<p class="text-left lg:text-3xl text-sm m-0">
Join Football Quiz, the ultimate game for football enthusiasts! Test your football knowledge, earn points, and stand a chance to win incredible prizes, including a trip to watch the EPL finals, cash prizes, and airtime. With a subscription price of N100 per day and N200 per week, enjoy multiple plays for an added fee of N50 per game. All MTN Nigeria customers with valid mobile numbers are eligible to participate. Subscribers receive 10 points daily, automatically qualifying them for the daily draw. Unleash your passion for football and embark on an exciting journey with Football Quiz today!

</p>

</div>
      </div>
    </>
  );
}

export default About;
